import { render, staticRenderFns } from "./VRadio.vue?vue&type=template&id=d656f5a4&scoped=true&"
import script from "./VRadio.vue?vue&type=script&lang=js&"
export * from "./VRadio.vue?vue&type=script&lang=js&"
import style0 from "./VRadio.vue?vue&type=style&index=0&id=d656f5a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d656f5a4",
  null
  
)

export default component.exports